const TOKEN_KEY = 'jwt_token';
const SAVE_TYPE = {
	SESSION: 'session',
	LOCAL: 'local',
	BOTH: 'both',
};
const {
	SESSION,
	LOCAL,
	BOTH,
} = SAVE_TYPE;

function getJWT() {
	try {
		return JSON.parse(sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY));
	} catch (error) {
		console.log(error);
		return undefined;
	}
}

function setJWT(value, saveType = SESSION) {
	switch (saveType) {
		case SESSION:
			sessionStorage.setItem(TOKEN_KEY, JSON.stringify(value));
			break;
		case LOCAL:
			localStorage.setItem(TOKEN_KEY, JSON.stringify(value));
			break;
		case BOTH:
			sessionStorage.setItem(TOKEN_KEY, JSON.stringify(value));
			localStorage.setItem(TOKEN_KEY, JSON.stringify(value));
			break;
		default:
			sessionStorage.setItem(TOKEN_KEY, JSON.stringify(value));
			break;
	}
}

function removeJWT() {
	sessionStorage.removeItem(TOKEN_KEY);
	localStorage.removeItem(TOKEN_KEY);
}

function initialize() {
	if (window.config?.jwt) {
		setJWT(window.config?.jwt);
	} else if (localStorage.getItem(TOKEN_KEY) && !sessionStorage.getItem(TOKEN_KEY)) {
		sessionStorage.setItem(TOKEN_KEY, localStorage.getItem(TOKEN_KEY));
	}

	return window.config?.jwt || getJWT();
}

const jwt = {
	_token: initialize(),

	get current() {
		return this._token;
	},

	set current(jwt) {
		this._token = jwt;
		setJWT(this._token, SESSION);
	},

	saveToLocal: function () {
		setJWT(this._token, BOTH);
	},

	removeCurrent: function () {
		this._token = null;
		removeJWT();
	},
};

export default jwt;
